import { render, staticRenderFns } from "./PossibleDuplicates.template.vue?vue&type=template&id=522de7c0&scoped=true&"
var script = {}
import style0 from "./PossibleDuplicates.template.vue?vue&type=style&index=0&id=522de7c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522de7c0",
  null
  
)

export default component.exports